import { database } from '../firebase';
import { ref, set } from '@firebase/database';
import citiesData from '../assets/cities.json';
import { API_ENDPOINTS } from '../config/api';

// Location data for India
const locationData = {
  "Andhra Pradesh": {
    cities: {
      "Srikakulam": {
        neighborhoods: [] // To be added later
      },
      "Parvathipuram Manyam": {
        neighborhoods: [] // To be added later
      },
      "Vizianagaram": {
        neighborhoods: [
          "Vizianagaram Urban",
          "Vizianagaram Rural",
          "Gantyada",
          "Poosapatirega",
          "Denkada",
          "Bhogapuram",
          "Srungavarapukota",
          "Jami",
          "Vepada",
          "Lakkavarapukota",
          "Kothavalasa",
          "Bondapalli",
          "Bobbili",
          "Ramabhadrapuram",
          "Badangi",
          "Therlam",
          "Gajapathinagaram",
          "Dattirajeru",
          "Mentada",
          "Cheepurupalli",
          "Garividi",
          "Gurla",
          "Merakamudidam",
          "Vangara",
          "Regidi Amadalavalasa",
          "Santhakaviti",
          "Rajam",
          "Nellimarla",
          "Balijipeta",
          "Garugubilli",
          "Gummalakshmipuram",
          "Jiyyammavalasa",
          "Komarada",
          "Kurupam"
        ]
      },
      "Visakhapatnam": {
        neighborhoods: [
          "Gajuwaka",
          "Pedagantyada",
          "Gopalapatnam",
          "Mulagada",
          "Maharanipeta",
          "Pendurthi",
          "Bheemunipatnam",
          "Anandapuram",
          "Padmanabham",
          "Visakhapatnam Rural",
          "Seethammadhara"
        ]
      },
      "Alluri Sitharama Raju": {
        neighborhoods: [] // To be added later
      },
      "Anakapalli": {
        neighborhoods: [
          "Atchutapuram",
          "Butchayyapeta",
          "Chodavaram",
          "Devarapalli",
          "Elamanchili",
          "Kasimkota",
          "K.Kotapadu",
          "Munagapaka",
          "Paravada",
          "Rambilli",
          "Sabbavaram",
          "Cheedikada",
          "Golugonda",
          "Kotauratla",
          "Madugula",
          "Makavarapalem",
          "Nakkapalli",
          "Narsipatnam",
          "Nathavaram",
          "Payakaraopeta",
          "Ravikamatham",
          "Rolugunta",
          "S. Rayavaram"
        ]
      },
      "Kakinada": {
        neighborhoods: [] // To be added later
      },
      "East Godavari": {
        neighborhoods: [] // To be added later
      },
      "Dr. B. R. Ambedkar Konaseema": {
        neighborhoods: [] // To be added later
      },
      "Eluru": {
        neighborhoods: [] // To be added later
      },
      "West Godavari": {
        neighborhoods: [] // To be added later
      },
      "NTR": {
        neighborhoods: [] // To be added later
      },
      "Krishna": {
        neighborhoods: [] // To be added later
      },
      "Palnadu": {
        neighborhoods: [] // To be added later
      },
      "Guntur": {
        neighborhoods: [
          "Arundelpet",
          "Brodipet",
          "Lakshmipuram",
          "Labbipet",
          "Nallapadu",
          "Pedakakani",
          "Sattenapalli",
          "Tadepalli",
          "Mangalagiri",
          "Tenali"
        ]
      },
      "Bapatla": {
        neighborhoods: [] // To be added later
      },
      "Sri Potti Sriramulu Nellore": {
        neighborhoods: [] // To be added later
      },
      "Prakasam": {
        neighborhoods: [] // To be added later
      },
      "Kurnool": {
        neighborhoods: [] // To be added later
      },
      "Nandyal": {
        neighborhoods: [] // To be added later
      },
      "Anantapuram": {
        neighborhoods: [] // To be added later
      },
      "Sri Sathya Sai": {
        neighborhoods: [] // To be added later
      },
      "YSR Kadapa": {
        neighborhoods: [] // To be added later
      },
      "Annamayya": {
        neighborhoods: [] // To be added later
      },
      "Tirupati": {
        neighborhoods: [
          "Alipiri",
          "Temple Town",
          "Tiruchanur",
          "Tirumala",
          "Renigunta",
          "Chandragiri",
          "Pakala",
          "Puttur",
          "Nagari",
          "Srikalahasti"
        ]
      },
      "Chittoor": {
        neighborhoods: [] // To be added later
      }
    }
  },
  "Telangana": {
    cities: {
      "Hyderabad": {
        neighborhoods: ["Banjara Hills", "Jubilee Hills", "Gachibowli", "Madhapur", "Hitech City", "Secunderabad", "Begumpet", "Ameerpet", "Kukatpally", "Dilsukhnagar", "Tolichowki", "Abids", "Sainikpuri", "Boduppal"]
      },
      "Warangal": {
        neighborhoods: ["Hanamkonda", "Kazipet", "Narsampet", "Parkal", "Jangaon", "Mahabubabad", "Bhupalpally", "Mulugu", "Eturnagaram", "Mahabubnagar"]
      },
      "Karimnagar": {
        neighborhoods: ["Huzurabad", "Sircilla", "Jagtial", "Peddapalli", "Manthani", "Husnabad", "Choppadandi", "Korutla", "Metpally", "Sultanabad"]
      }
    }
  },
  "Karnataka": {
    cities: {
      "Bangalore": {
        neighborhoods: ["Koramangala", "Indiranagar", "Whitefield", "Electronic City", "Marathahalli", "HSR Layout", "BTM Layout", "JP Nagar", "Hebbal", "Malleswaram", "Rajajinagar", "Basavanagudi", "Jayanagar", "Vijayanagar"]
      },
      "Mysore": {
        neighborhoods: ["Vijayanagar", "Hebbal", "Kuvempunagar", "Saraswathipuram", "Gokulam", "Chamundipuram", "Vidyaranyapuram", "Bogadi", "T Narasipura", "Nanjangud"]
      },
      "Hubli-Dharwad": {
        neighborhoods: ["Vidyanagar", "Gandhinagar", "Keshwapur", "Navanagar", "Sattur", "Deshpande Nagar", "Karnataka University", "Saptapur", "Old Hubli", "New Hubli"]
      }
    }
  },
  "Tamil Nadu": {
    cities: {
      "Chennai": {
        neighborhoods: ["T Nagar", "Anna Nagar", "Adyar", "Velachery", "Porur", "OMR", "Ambattur", "Vadapalani", "Mylapore", "Kilpauk", "Saidapet", "Guindy", "Perambur", "Thiruvanmiyur"]
      },
      "Coimbatore": {
        neighborhoods: ["RS Puram", "Saibaba Colony", "Peelamedu", "Singanallur", "Race Course", "Gandhipuram", "Lakshmi Mills", "Ukkadam", "Kovaipudur", "Saravanampatti"]
      },
      "Madurai": {
        neighborhoods: ["Anna Nagar", "KK Nagar", "Villapuram", "Tallakulam", "Goripalayam", "Simmakkal", "Yanaikkal", "Koodal Nagar", "Arapalayam", "Thirunagar"]
      }
    }
  },
  "Maharashtra": {
    cities: {
      "Mumbai": {
        neighborhoods: ["Andheri", "Bandra", "Powai", "Worli", "Colaba", "Juhu", "Dadar", "Borivali", "Thane", "Navi Mumbai", "Chembur", "Ghatkopar", "Vasai", "Virar"]
      },
      "Pune": {
        neighborhoods: ["Koregaon Park", "Kalyani Nagar", "Viman Nagar", "Hinjewadi", "Wakad", "Baner", "Aundh", "Kharadi", "Magarpatta", "Hadapsar", "Katraj", "Kondhwa"]
      },
      "Nagpur": {
        neighborhoods: ["Dharampeth", "Ramdaspeth", "Sitabuldi", "Sadar", "Civil Lines", "Wardha Road", "Koradi", "Kamptee", "Butibori", "Hingna"]
      }
    }
  },
  "Delhi": {
    cities: {
      "New Delhi": {
        neighborhoods: ["Connaught Place", "Lajpat Nagar", "Saket", "Hauz Khas", "Vasant Kunj", "Dwarka", "Rohini", "Pitampura", "Janakpuri", "Rajouri Garden", "Greater Kailash", "Defence Colony"]
      },
      "Gurgaon": {
        neighborhoods: ["Cyber City", "DLF Phase 1-5", "Sector 29", "Sohna Road", "MG Road", "Sector 56", "Sector 57", "Sector 23", "Sector 14", "Sector 15"]
      },
      "Noida": {
        neighborhoods: ["Sector 62", "Sector 18", "Sector 15", "Sector 51", "Sector 76", "Sector 77", "Sector 78", "Sector 79", "Sector 80", "Sector 81"]
      }
    }
  }
};

// Get all states
export const getStates = () => {
  // Use the states from the JSON file
  return Object.keys(citiesData);
};

// Get cities for a state
export const getCitiesByState = (state) => {
  if (!state || !citiesData[state]) return [];
  // Return array of city objects
  return citiesData[state].map(city => ({
    name: city.name,
    lat: city.lat,
    lng: city.lng
  }));
};

// Get neighborhoods for a city (fallback to old structure for major cities)
export const getNeighborhoodsByCity = (state, city) => {
  if (!state || !city || !locationData[state]?.cities[city]) return [];
  return locationData[state].cities[city].neighborhoods;
};

// Get current location using browser's geolocation API
export const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by your browser'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        });
      },
      (error) => {
        reject(error);
      }
    );
  });
};

// Calculate distance between two points using Haversine formula
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in km
  return distance;
};

const deg2rad = (deg) => {
  return deg * (Math.PI / 180);
};

// Find nearest ads based on user's location
export const findNearestAds = (userLat, userLon, ads, maxDistance = 50) => {
  return ads
    .filter(ad => {
      if (!ad.coordinates?.coordinates) return false;
      const [adLon, adLat] = ad.coordinates.coordinates;
      const distance = calculateDistance(userLat, userLon, adLat, adLon);
      return distance <= maxDistance;
    })
    .sort((a, b) => {
      const [aLon, aLat] = a.coordinates.coordinates;
      const [bLon, bLat] = b.coordinates.coordinates;
      const distA = calculateDistance(userLat, userLon, aLat, aLon);
      const distB = calculateDistance(userLat, userLon, bLat, bLon);
      return distA - distB;
    });
};

function haversine(lat1, lon1, lat2, lon2) {
  const R = 6371; // km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
}

export const getLocationFromCoordinates = async (latitude, longitude) => {
  console.log('getLocationFromCoordinates called with:', { latitude, longitude });
  try {
    const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`);
    const data = await response.json();
    console.log('Response from Nominatim:', data);

    // Parse the address components
    const address = data.address;
    let apiState = address.state || '';
    let apiCity = address.city || address.town || address.village || '';
    let apiNeighborhood = address.suburb || address.neighbourhood || '';

    console.log('Parsed address components (API):', { apiState, apiCity, apiNeighborhood });

    let resultState = '';
    let resultCity = '';
    let resultNeighborhood = '';

    // Try to find a matching state in our data
    const matchingState = Object.keys(citiesData).find(
      s => apiState && s.toLowerCase() === apiState.toLowerCase()
    );
    console.log('Matching state from local data:', matchingState);

    if (matchingState) {
      resultState = matchingState;
      // Try to find a matching city by name
      const stateCities = citiesData[matchingState];
      let matchingCityObj = stateCities.find(
        c => apiCity && c.name && c.name.toLowerCase() === apiCity.toLowerCase()
      );
      if (!matchingCityObj && stateCities.length > 0) {
        // No name match: find nearest city by coordinates
        let minDist = Infinity;
        let nearestCity = null;
        for (const city of stateCities) {
          if (city.lat && city.lng) {
            const dist = haversine(latitude, longitude, city.lat, city.lng);
            if (dist < minDist) {
              minDist = dist;
              nearestCity = city;
            }
          }
        }
        matchingCityObj = nearestCity;
      }
      if (matchingCityObj) {
        resultCity = matchingCityObj.name;
        // Neighborhoods: fallback to old structure if available
        if (matchingState in locationData && locationData[matchingState].cities[resultCity]) {
          const cityNeighborhoods = locationData[matchingState].cities[resultCity]?.neighborhoods || [];
          const matchingNeighborhood = cityNeighborhoods.find(n =>
            apiNeighborhood && n.toLowerCase() === apiNeighborhood.toLowerCase()
          );
          if (matchingNeighborhood) {
            resultNeighborhood = matchingNeighborhood;
          } else if (cityNeighborhoods.length > 0) {
            resultNeighborhood = cityNeighborhoods[0];
          }
        }
      }
    }
    const finalLocation = { state: resultState, city: resultCity, neighborhood: resultNeighborhood };
    console.log('Returning processed location:', finalLocation);
    return finalLocation;
  } catch (error) {
    console.error('Error getting location from coordinates:', error);
    throw error;
  }
};

export const saveUserLocation = async (userId, location) => {
  try {
    await set(ref(database, `users/${userId}/location`), {
      latitude: location.latitude,
      longitude: location.longitude,
      lastUpdated: Date.now()
    });
    return true;
  } catch (error) {
    console.error('Error saving location:', error);
    return false;
  }
};

export const getNearbyAds = async (latitude, longitude, radius = 10) => {
  try {
    const response = await fetch(`${API_ENDPOINTS.ADS.NEARBY}?lat=${latitude}&lng=${longitude}&radius=${radius}`);
    if (!response.ok) throw new Error('Failed to fetch nearby ads');
    return await response.json();
  } catch (error) {
    console.error('Error fetching nearby ads:', error);
    throw error;
  }
}; 